import { Stack, Typography } from "@mui/material";

export const NotFoundPage = () => {
  return (
    <Stack
      sx={{ width: "100vw", height: "100vh" }}
      alignItems={"center"}
      justifyContent={"center"}
    >
      <Typography sx={{ fontSize: "20px" }}>
        Không tồn tại. Vui lòng kiểm tra lại đường dẫn !
      </Typography>
    </Stack>
  );
};
